import { useIntl } from 'react-intl';
import { useSwiper } from 'swiper/react';

import { Svg } from '@components/Svg';

import { carouselMessages } from '@data/ui-messages/carousel';

export const CarouselNavigation: React.VFC = () => {
	const swiper = useSwiper();
	const intl = useIntl();

	return (
		<>
			<button
				aria-label={intl.formatMessage(carouselMessages.previousLabel)}
				className="swiper-button-prev"
				onClick={() => swiper.slidePrev()}
				type="button"
			>
				<Svg id="arrow-left" />
			</button>

			<button
				aria-label={intl.formatMessage(carouselMessages.nextLabel)}
				className="swiper-button-next"
				onClick={() => swiper.slideNext()}
				type="button"
			>
				<Svg id="arrow-left" />
			</button>
		</>
	);
};
